<template>
  <div class="edit-page-wrapper">
    <form
        autocomplete="off"
        @submit.prevent="handleFormSubmit"
        v-if="!preloaderVisibility"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <h2>Information</h2>
            <label>
              <input
                  type="text"
                  placeholder="First Name"
                  v-model="userInfo.firstName"
                  :class="{'not-filled': highlightingData.firstName}"
              >
            </label>
            <label>
              <input
                  type="text"
                  placeholder="Last Name"
                  v-model="userInfo.lastName"
                  :class="{'not-filled': highlightingData.lastName}"
              >
            </label>
          </div>
          <div class="col-6">
            <h2>Authentication</h2>
            <label>
              <select
                required
                v-if="newUserStatus"
                v-model="selectedUserType"
                name="userType" 
                id="usertype"
                >
                  <option value="" disabled selected>User Type</option>
                  <option value="INSTRUCTOR">Instructor</option>
                  <option value="STUDENT">Student</option>
              </select>
              <input
                  v-else
                  type="text"
                  autocomplete="off"
                  placeholder="User Role"
                  disabled
                  v-model="userRole"
              >
            </label>
            <label>
              <input
                  type="email"
                  autocomplete="off"
                  placeholder="User Email"
                  :class="{'not-filled': highlightingData.email}"
                  v-model="userInfo.email"
              >
            </label>
            <label for="password">
              <input
                  id="password"
                  type="password"
                  autocomplete="off"
                  placeholder="New Password"
                  minlength="6"
                  :required="isRequiredPass"
                  v-model="userInfo.password"
              >
            </label>
            <label for="confirm-password">
              <input
                  id="confirm-password"
                  type="password"
                  placeholder="Confirm New Password"
                  minlength="6"
                  v-model="validateFields.passwordConfirm"
              >
            </label>
          </div>
          <div class="col-6" />
          <div class="col-6" v-if="isAvailableAssign">
            <h2>Assign Instructor</h2>
            <vueSelect
             v-model="assignedInstructors" 
             :options="availableInstructors"
             label="fullName"
             clearable
             multiple
             appendToBody
             :closeOnSelect="false"
            />
          </div>
        </div>
        <div class="row" v-if="errorMessage.length">
          <div class="col-6">
            <div class="errors-wrapper">
              <div v-for="(singleError, index) in errorMessage" :key="index">{{ singleError }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 buttons-wrapper">
            <button type="button" class="cancel delete" :disabled="isDeleteDisabled" v-if="!newUserStatus" @click.prevent="handlePopupOpen">Delete</button>
          </div>
          <div class="col-6 align-end buttons-wrapper">
            <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
            <input type="submit" class="save" value="Save">
          </div>
        </div>
      </div>
    </form>
    <PreloaderComponent
        v-if="preloaderVisibility"
    />
    <ModalWindow
        v-if="modalView"
        :id="id"
        @deleteUser="handleDeleteUser"
        @closePopup="handlePopupClose"
    />
  </div>
</template>

<script>
import vueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'


import CheckAPI from '@/api'
import ModalWindow from '@/components/common/ModalWindow'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export default {
  name: "EditUserForm",
  data() {
    return {
      id: this.$route.params.id,
      modalView: false,
      userInfo: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
      },
      userRole: '',

      newUserStatus: false,

      assignedInstructors: [],
      availableInstructors: [],
      allInstrc: [],

      selectedUserType: '',
      userTypes: ['INSTRUCTOR', 'STUDENT'],

      validateFields: {
        passwordConfirm: ''
      },

      errorMessage: [],

      preloaderVisibility: true,

      highlightingData: {
        firstName: false,
        lastName: false,
        email: false,
      },
    }
  },
  components: {
    vueSelect,
    ModalWindow,
    PreloaderComponent
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getSelectedInst(value) {
      this.isntrSearch = value;
    },

    async getUser() {
      if (this.$route.params.id) {
        const user = await CheckAPI.getUserById(this.id)
        if (user) {
          const { data } = user;
          this.userInfo.firstName = data.data.firstName;
          this.userInfo.lastName = data.data.lastName;
          this.userInfo.email = data.data.email;
          this.userRole = data.data.userRole.toLowerCase()[0].toUpperCase() + data.data.userRole.toLowerCase().substring(1);
          if (data.data.userRole !== 'INSTRUCTOR' && data.data.userRole !== 'ADMIN') {
            const newInstr = data.data.availableInstructors.map(item => ({
              ...item,
              fullName: item.firstName.trim() + ' ' + item.lastName.trim()
            }));
            const newAssInstr = data.data.assignedInstructors.map(item => ({
              ...item,
              fullName: item.firstName.trim() + ' ' + item.lastName.trim()
            }));
            this.assignedInstructors = newAssInstr
            const fullArray = [...newInstr, ...newAssInstr];
            const sortedArray = newInstr.sort(function(a, b){
                if(a.firstName < b.firstName) { return -1; }
                if(a.firstName > b.firstName) { return 1; }
                return 0;
            })
            this.availableInstructors = sortedArray
            this.allInstrc = JSON.parse(JSON.stringify(fullArray))
          }
        }
      } else {
        this.newUserStatus = true;
      }
      this.preloaderVisibility = false
    },

    handlePopupClose() {
      this.modalView = false
    },

    handlePopupOpen() {
      this.modalView = true
    },

    async handleDeleteUser() {
      await CheckAPI.deleteUserById(this.id)
      this.modalView = false
      this.handleRedirect()
    },

    handleRedirect() {
      this.$router.push({
        path: '/?page=1'
      })
    },

    async handleFormSubmit() {
      if (!this.formValidation().length) {
        if (this.newUserStatus) {
          this.handleNewUserCreate();
        } else {
          const filteredInstr = this.assignedInstructors.map(item => item.userId);
          const newUserData = {
            ...this.userInfo,
            instructorIds: filteredInstr,
            ...(this.userInfo.password ? { password: this.userInfo.password } : { password: null }),
            userId: this.id
          }
          await CheckAPI.setUserInfoById(newUserData)
        }
      }
    },

    async handleNewUserCreate() {
      const dataToSend = {
        ...this.userInfo,
        userRole: this.selectedUserType
      };
      await CheckAPI.createNewUser(dataToSend)
    },

    formValidation() {
      this.errorMessage = [];
      this.highlightingData = {
        firstName: false,
        lastName: false,
        passwordConfirm: false,
        password: false,
        email: false
      }
      const {
        email,
        firstName,
        lastName,
        password
      } = this.userInfo

      if (!email.trim()) {
        this.highlightingData.email = true
        this.errorMessage.push('Please specify email address')
      }
      if (!firstName.trim()) {
        this.highlightingData.firstName = true
        this.errorMessage.push('Please specify first name')
      }
      if (!lastName.trim()) {
        this.highlightingData.lastName = true
        this.errorMessage.push('Please specify last name')
      }
      if (password && password !== this.validateFields.passwordConfirm) {
        this.errorMessage.push('Password and confirm fields should be the same')
      } 

      return this.errorMessage;
    }
  },
  computed: {
    isRequiredPass() {
      if (this.newUserStatus) {
        return true
      }
      return !!this.validateFields.passwordConfirm.length
    },
    isDeleteDisabled() {
      return this.userRole === 'Admin'
    },
    isAvailableAssign() {
      if (this.newUserStatus) {
        return false
      }
      if (this.userRole !== 'Instructor' && this.userRole !== 'Admin') {
        return true
      }
      return false
    }
  },
  watch: {
    assignedInstructors: {
      deep: true,
      handler(newValue) {
        const ids = newValue.map(singleValue => singleValue.userId);
        const mergedArray = [...this.allInstrc];
        const newAvailableInstructors = mergedArray.filter(singleInst => !ids.includes(singleInst.userId))
        const sortedArray = newAvailableInstructors.sort(function(a, b){
                if(a.firstName < b.firstName) { return -1; }
                if(a.firstName > b.firstName) { return 1; }
                return 0;
            })
        this.availableInstructors = sortedArray;
      }
    }
  }
}
</script>

<style scoped lang="scss">

.cancel {
    background-color: transparent;
    border: .0625em solid #141638;

    &.delete {
        background-color: #ff8900;
        width: 150px !important;
        color: white;
        border: none;

       &[disabled="disabled"] {
         background-color: #eee;
         color: #00000082;
         cursor: not-allowed;

         &:hover {
          background-color: #eee;
          color: #00000082;
         }
       }

        &:hover {
            color: white;
        }
    }

    &:hover {
        color: #141638;
    }
}

.cancel,
.save {
    width: 100px !important;
    height: 30px !important;
    border-radius: .75em !important;
    text-align: center !important;
    cursor: pointer;
}

.save {
    margin-left: 15px;
    background-color: #08ce97 !important;
    border-style: none;
    color: #fff !important;
    border-radius: 0.75em;
    display: block !important;
    margin: 0 !important;
    margin-left: 15px !important;
    padding: 5px;

    &:hover {
      color: white !important;
      background-color: #34558b !important;
    }
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 15px;
}

input {
  -webkit-appearance: none;
}

.row {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}

.col-6 {
  @media (min-width: 1199px) {
    flex: 0 50%;
    max-width: 50%;
  }

  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 15px;
  flex: 0 1 100%;
  max-width: 100%;

  &.buttons-wrapper {
    flex-direction: row;
    @media (max-width: 767px) {
      justify-content: center;
      margin-bottom: 10px;
    }
  }

  &.align-end {
    justify-content: flex-end;

    @media (max-width: 767px) {
      justify-content: space-between;
    }
  }
}


.edit-page-wrapper {
  padding: 10px;

  .v-select.vs--single.vs--searchable {
    margin-bottom: 20px;
  }

  input {
    &[disabled="disabled"] {
      background-color: #cbdae3;
    }
    box-sizing: border-box;
    display: block;
    background-color: #fff;
    border: none;
    color: black;
    border-radius: 6px;
    width: 100%;
    margin: 0 auto 20px;

    &:focus {
      outline: none;
    }

    &.not-filled {
      border: 1px solid red;
    }
  }

  button,
  input[type="submit"] {
    box-sizing: border-box;
    background-color: #fff;
    border: none;
    color: black;
    border-radius: 6px;
    width: 150px;
    margin: 0 10px 0 0;
    cursor: pointer;
    transition: ease all .4s;

    @media (max-width: 767px) {
      margin: 0
    }

    &:focus {
      outline: none;
    }

    &:hover {
      color: white;
      background-color: #34558b;
    }

    &:last-child {
      margin: 0;
    }
  }

  .isRequired {
    .v-select.vs--single.vs--searchable,
    input {
      border: 1px solid red;
    }
  }
}
</style>